import React from 'react';
import { Download, Calendar, MapPin, Mail } from 'lucide-react';

const About: React.FC = () => {
  const handleDownloadResume = () => {
    const link = document.createElement('a');
    link.href = '/Michael Guevarra Resume.pdf';
    link.download = 'Michael Guevarra Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const experience = [
    {
      title: 'Senior Frontend Developer',
      company: 'Tech Company',
      period: '2022 - Present',
      description: 'Leading frontend development for web applications using React, TypeScript, and modern web technologies.',
    },
    {
      title: 'Full Stack Developer',
      company: 'Startup Inc',
      period: '2020 - 2022',
      description: 'Developed full-stack applications using React, Node.js, and PostgreSQL.',
    },
    {
      title: 'Junior Developer',
      company: 'Digital Agency',
      period: '2018 - 2020',
      description: 'Built responsive websites and web applications using modern frontend frameworks.',
    },
  ];

  const education = [
    {
      degree: 'Bachelor of Computer Science',
      school: 'University of Technology',
      period: '2014 - 2018',
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-white/40 section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold text-secondary-900 mb-6">
                About Me
              </h1>
              <p className="text-xl text-secondary-600 mb-8">
                I&apos;m a passionate developer with over 5 years of experience creating
                innovative digital solutions. I love turning complex problems into
                simple, beautiful, and intuitive designs.
              </p>
              <div className="space-y-4">
                <div className="flex items-center text-secondary-600">
                  <MapPin className="h-5 w-5 mr-3" />
                  <span>Based in San Francisco, CA</span>
                </div>
                <div className="flex items-center text-secondary-600">
                  <Calendar className="h-5 w-5 mr-3" />
                  <span>Available for new opportunities</span>
                </div>
                <div className="flex items-center text-secondary-600">
                  <Mail className="h-5 w-5 mr-3" />
                  <span>michael@michaelguevarra.com</span>
                </div>
              </div>
              <button className="btn-primary mt-6 inline-flex items-center" onClick={handleDownloadResume}>
                <Download className="h-5 w-5 mr-2" />
                Download Resume
              </button>
            </div>
            <div className="relative">
              <div className="bg-gradient-to-br from-primary-400 to-primary-600 rounded-2xl p-8 text-white">
                <h3 className="text-2xl font-bold mb-4">What I Do</h3>
                <ul className="space-y-3">
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-white rounded-full mr-3"></span>
                    Frontend Development with React & TypeScript
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-white rounded-full mr-3"></span>
                    Backend Development with Node.js
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-white rounded-full mr-3"></span>
                    UI/UX Design & Prototyping
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-white rounded-full mr-3"></span>
                    Database Design & Management
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="section-padding">
        <div className="container-max">
          <h2 className="text-3xl font-bold text-secondary-900 mb-12 text-center">
            Experience
          </h2>
          <div className="space-y-8">
            {experience.map((job, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <div>
                    <h3 className="text-xl font-semibold text-secondary-900">
                      {job.title}
                    </h3>
                    <p className="text-primary-600 font-medium">{job.company}</p>
                  </div>
                  <span className="text-secondary-500 text-sm mt-2 md:mt-0">
                    {job.period}
                  </span>
                </div>
                <p className="text-secondary-600">{job.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Education Section */}
      <section className="section-padding">
        <div className="container-max">
          <h2 className="text-3xl font-bold text-secondary-900 mb-12 text-center">
            Education
          </h2>
          <div className="max-w-2xl mx-auto">
            {education.map((edu, index) => (
              <div key={index} className="text-center">
                <h3 className="text-xl font-semibold text-secondary-900 mb-2">
                  {edu.degree}
                </h3>
                <p className="text-primary-600 font-medium mb-2">{edu.school}</p>
                <p className="text-secondary-500">{edu.period}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 